module.exports = __webpack_public_path__ + "static/media/week7-bomberman-game.bca8a220.md";